// extracted by mini-css-extract-plugin
export default {"link":"yN-z","disabled":"zN-z"};